/* eslint-disable @typescript-eslint/indent */
import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BranchDataParsed } from 'Types/GlobalTypes';
import { selectData, selectLoading } from 'Selector/BranchSelector';
import { navigateToAuthServer } from 'Utils/UtilityFunctions';
import { selectShowChatbot, selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import {
  COMPANY_NEWS_ROUTE, COMPANY_OVERVIEW_ROUTE, FEED_GILROY_ROUTE,
  FEED_NEWS_ROUTE, FEED_ROUTE, FEED_SPOTLIGHT_ROUTE, PERSONALITY_INSIGHTS_ROUTE,
} from 'Utils/Constants';

const DeepLinkView = function DeepLinkView() {
  const navigate = useNavigate();

  const branchLoading = useSelector(selectLoading);
  const branchData = useSelector(selectData);
  const chatbotAllowed = useSelector(selectShowChatbot);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);

  const switchFunction = (obj: BranchDataParsed) => {
    if (!isEmpty(obj)) {
      const id = obj.id || obj.$canonical_identifier;
      const articleLink = chatbotAllowed && showGlobalGilroy ? `${FEED_GILROY_ROUTE}?articleId=${id}` : `${FEED_SPOTLIGHT_ROUTE}?articleId=${id}`;
      switch (obj.entity) {
        case 'article':
          navigate(articleLink);
          break;
        case 'person':
          navigate(`${PERSONALITY_INSIGHTS_ROUTE}${id}&personType=EXECUTIVE`);
          break;
        case 'company':
          navigate(`${COMPANY_NEWS_ROUTE}${id}&scroll=true`);
          break;
        case 'person_share':
          navigate(`${PERSONALITY_INSIGHTS_ROUTE}${id}&personType=EXECUTIVE`);
          break;
        case 'company_share':
          navigate(`${COMPANY_OVERVIEW_ROUTE}${id}`);
          break;
        case 'login':
          navigateToAuthServer();
          break;
        case 'reset_password':
          navigate(`/password?option=reset_password&key=${obj.key}`);
          break;
        case 'widget':
          if (obj.type === 'alert_feeds' || obj.type === 'news_layout_2' || obj.type_widget === 'alert_feeds') {
            navigate(`${FEED_NEWS_ROUTE}?scroll=true`);
          }
          break;
        default:
          navigate(FEED_ROUTE);
      }
    } else {
      navigate(FEED_ROUTE);
    }
  };

  useEffect(() => {
    if (branchData && branchLoading === false) {
      const { data_parsed: dataParsed } = branchData;
      switchFunction(dataParsed);
    }
  }, [branchLoading]);

  return <div />;
};

export default DeepLinkView;
